var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScreen = function SvgIconScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.333a4.333 4.333 0 0 0-4.333 4.333v12.667A4.333 4.333 0 0 0 7 26.666h10.336a5.142 5.142 0 0 1-.003-.166v-.138a3.697 3.697 0 0 1 3.698-3.696h.37a4.666 4.666 0 1 1 7.932-3.333V9.666A4.335 4.335 0 0 0 25 5.333H7Zm21 14a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0Zm2.667 7.167c0 2.074-1.715 4.166-6 4.166-4.286 0-6-2.084-6-4.166v-.138A2.362 2.362 0 0 1 21.03 24h7.272a2.362 2.362 0 0 1 2.364 2.362v.138Z",
    fill: "#fff"
  })));
};
export default SvgIconScreen;